<div class="dex-lp-compos_table-wrapper" customScrollbar>
    <div class="dex-lp-compos_complex-table" [table]="table" #tableElement>
        <div class="dex-lp-compos_table-header-wrapper">
            <table class="dex-lp-compos_table">
                <thead>
                <tr tableHeaderRow>
                    <th textHiding *tableColumn="table.columnsDict.ID; let column" class="dex-lp-compos_table_header"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.SYMBOL; let column" class="dex-lp-compos_table_header"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.BALANCE; let column" class="dex-lp-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.ENTRY_VALUE; let column" class="dex-lp-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.RATE; let column" class="dex-lp-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.PORTFOLIO_VALUE; let column" class="dex-lp-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.UNREALISED_PNL; let column" class="dex-lp-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.UNREALISED_PNL_PERCENT; let column" class="dex-lp-compos_table_header -align-right"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                    <th textHiding *tableColumn="table.columnsDict.COUNTERPARTY; let column" class="dex-lp-compos_table_header"
                        [tooltipL10n]="column.label">
                        <span>{{column.label | l10n}}</span>
                    </th>
                </tr>
                </thead>
            </table>
        </div>
        <div class="dex-lp-compos_table-body-wrapper" customScrollbar elementRuler>
            <table class="dex-lp-compos_table">
                <tbody>
                <tr *tableBodyRow="let _row of table.rows"
                    class="dex-lp-compos_table_row">

                    @let row = getTypedRow(_row);

                    <td textHiding *tableColumn class="dex-lp-compos_table_cell"
                        [tooltip]="row.id">
                        <span>{{row.id}}</span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell -symbol"
                        [tooltip]="row.symbol + ' ' + row.symbol">
                        <span>
                            {{row.symbol}} <span class="-full-name">{{row.symbol}}</span>
                        </span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell -align-right"
                        tooltip #balanceTooltip="tooltip">
                        <span [displayDecimal]="row.raw.balance | valueWithDelDisplayDecimal:false" [tooltipDirective]="balanceTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell -align-right"
                        tooltip #entryValueTooltip="tooltip">
                        <span [displayDecimal]="row.raw.entryValue | valueWithDelDisplayDecimal:false" [tooltipDirective]="entryValueTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell -align-right"
                        tooltip #rateTooltip="tooltip">
                        <span [displayDecimal]="row.raw.referenceRate | valueWithDelDisplayDecimal:false" [tooltipDirective]="rateTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell -align-right"
                        tooltip #portfolioValueTooltip="tooltip">
                        <span [displayDecimal]="row.raw.portfolioValue | valueWithDelDisplayDecimal:false" [tooltipDirective]="portfolioValueTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell -align-right"
                        tooltip #unrealisedPnlTooltip="tooltip">
                        <span [displayDecimal]="row.raw.profitOrLoss | valueWithDelDisplayDecimal:false" [tooltipDirective]="unrealisedPnlTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell -align-right"
                        tooltip #unrealisedPnlPercentTooltip="tooltip">
                        <span [displayDecimal]="row.unrealisedPnlPercent" [decimalCount]="2" currency="%" [tooltipDirective]="unrealisedPnlPercentTooltip"></span>
                    </td>
                    <td textHiding *tableColumn class="dex-lp-compos_table_cell"
                        [tooltip]="row.counterparty">
                        <span>
                            <span class="dex-lp-compos_table_cell_counterparty">
                                <wallet-avatar
                                    class="dex-lp-compos_table_cell_counterparty-avatar"
                                    [address]="row.counterparty"
                                    [isChangeOnClickEnabled]="true">
                                </wallet-avatar>
                                <span>{{ row.counterparty | shortenWalletAddr }}</span>
                            </span>
                        </span>
                    </td>
                </tr>

                <!-- EMPTY ROWS -->
                <tr *tableBodyEmptyRow class="dex-lp-compos_table_row -empty">
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                    <td *tableColumn class="dex-lp-compos_table_cell"></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
